import React from 'react';
import styles from './About.module.css';
import { ArrowLeftIcon } from '../components/Icons';
import { useNavigate } from 'react-router-dom';

const About = () => {
  const navigate = useNavigate();

  return (
    <div className={styles.wrapper}>
      <header className={styles.header}>
        <button
          type="button"
          className={styles.backBtn}
          onClick={() => navigate(-1)}
          aria-label="返回上一页"
        >
          <ArrowLeftIcon size={20} />
        </button>
        <h1 className={styles.title}>关于我们</h1>
      </header>

      <main className={styles.content}>
        <section className={styles.section}>
          <h2 className={styles.sectionTitle}>我们的愿景</h2>
          <p className={styles.sectionText}>
            我们致力于为中文读者提供更加高效、愉悦的英语阅读学习体验，通过精选小说与智能工具，帮助您在沉浸式阅读中不断提升语言能力。
          </p>
        </section>

        <section className={styles.section}>
          <h2 className={styles.sectionTitle}>团队介绍</h2>
          <p className={styles.sectionText}>
            团队成员来自教育科技与互联网行业，拥有丰富的产品、教学与技术背景。我们相信，阅读是提升语言能力的最佳方式之一，也是探索世界的窗口。
          </p>
        </section>

        <section className={styles.section}>
          <h2 className={styles.sectionTitle}>合作联系</h2>
          <p className={styles.sectionText}>
            如果您有商务合作、教育合作或媒体采访需求，欢迎通过以下邮箱与我们取得联系：
          </p>
          <a className={styles.contactLink} href="mailto:xxx@gmail.com">
            xxx@gmail.com
          </a>
        </section>
      </main>
    </div>
  );
};

export default About;
